export const appConfig = {
    apiBaseUrl: 'https://ct-shuifung.lttapp.com/api',
    endpoints: {
        auth: {
            login: '/auth/login',
            logout: '/auth/logout',
            refresh: '/auth/refresh'
        },
        jobs: {
            list: '/jobs/list',
            userJobs: '/jobs/userJobs',
            create: '/jobs/create',
            update: '/jobs/update',
            delete: '/jobs/delete',
            status: '/jobs/status',
            uploadPaymentProof: '/jobs/uploadPaymentProof'
        },
        profit: {
            calculate: '/profit/calculate',
            list: '/profit/list'
        },
        users: {
            list: '/users',
            create: '/users/create',
            update: '/users/update',
            delete: '/users/delete'
        },
        documents: {
            quotation: '/documents/quotation',
            invoice: '/documents/invoice',
            upload: '/documents/upload'
        },
        reports: {
            jobs: '/reports/jobs',
            agents: '/reports/agents',
            vendors: '/reports/vendors'
        },
        events: {
            list: '/events',
            create: '/events/create',
            update: '/events/update',
            delete: '/events/delete'
        },
        projects: {
            list: '/projects/getList',
            availableProject: '/projects/getAvailableProject',
            availableStaff: '/projects/getAvailableStaff',
            getOne: '/projects/getOne'
        }
    },
    roles: {
        admin: {
            canManageUsers: true,
            canManageJobs: true,
            canGenerateReports: true,
            canManageSettings: true
        },
        account_manager: {
            canManageJobs: true,
            canAssignVendors: true,
            canViewReports: true
        },
        agent: {
            canCreateJobs: true,
            canGenerateQuotations: true,
            canGenerateInvoices: true,
            canUploadDocuments: true,
            canViewProfit: true
        },
        vendor: {
            canViewAssignedJobs: true,
            canUpdateJobStatus: true,
            canViewProfit: true
        }
    }
} as const;

export type AppConfig = typeof appConfig;
